/**
 * What the row menu's Copy actions put on the clipboard. The text is the cell as
 * the grid shows it (formatted dates, prices, combo labels), except where the grid
 * masks a value for privacy (e-mail "abc****com"): there the real value is copied,
 * which the cell already shows in its tooltip — customer service needs the address
 * itself to search for a customer's other transactions.
 */
import type { AskRowColumn } from "./askRowPrompt.ts";

/** The grid's privacy mask (cellRenderer's censorGdpr) inserts this. */
const MASK = "****";

export function cellCopyText(
  column: string,
  row: readonly unknown[],
  colIndex: Record<string, number>,
  cellTexts: Record<string, string>,
): string {
  const shown = cellTexts[column] ?? "";
  if (shown && !shown.includes(MASK)) return shown;
  const idx = colIndex[column];
  const raw = idx == null || idx < 0 ? undefined : row[idx];
  if (raw == null || raw === "") return shown;
  return String(raw).trim();
}

/** Every titled, non-empty cell of the row as "Title: value" lines. */
export function rowCopyText(
  columns: readonly AskRowColumn[],
  row: readonly unknown[],
  colIndex: Record<string, number>,
  cellTexts: Record<string, string>,
): string {
  const lines: string[] = [];
  for (const column of columns) {
    const title = column.title.trim();
    if (!title) continue;
    const text = cellCopyText(column.name, row, colIndex, cellTexts);
    if (text) lines.push(`${title}: ${text}`);
  }
  return lines.join("\n");
}
